// Generated types for ItemDefinition
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { SysMLStructureReadAPI, SysMLStructureWriteAPI } from './sysmlstructure';
import { SysMLStructureReadAPISchemaObject, SysMLStructureWriteAPISchemaObject } from './sysmlstructure';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface ItemDefinitionReadAPI extends SysMLStructureReadAPI {
}

export interface ItemDefinitionWriteAPI extends SysMLStructureWriteAPI {
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const ItemDefinitionReadAPISchemaObject = SysMLStructureReadAPISchemaObject.extend({}).passthrough();
export const ItemDefinitionReadAPISchema: z.ZodType<ItemDefinitionReadAPI> = ItemDefinitionReadAPISchemaObject;

export const ItemDefinitionWriteAPISchemaObject = SysMLStructureWriteAPISchemaObject.extend({}).passthrough();
export const ItemDefinitionWriteAPISchema: z.ZodType<ItemDefinitionWriteAPI> = ItemDefinitionWriteAPISchemaObject;
